import React, { useContext, useEffect, useState } from "react";
import DataTable from "react-data-table-component";

import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import FilterComponent from "../../FilterComponents/FilterComponent";
import ModalUploadDokumen from "../components/ModalUploadDokumen";
import { useThemeContext } from "../../../Context/ThemeContext";
import { filterSearch } from "../../../Utils/FilterItems";
import DaftarColumns from "../constants/DaftarColumns";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useDokumen } from "../../../Context/DokumenContext";

const DokumenContain = () => {
  const dokumenAPI = useDokumen();
  const { checkPermission } = useContext(RoleContext)
  const [filterText, setFilterText] = useState("");
  const [dokumen, setDokumen] = useState([]);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const { themeContext } = useThemeContext();

  useEffect(() => {
    getDokumenList();
  }, []);

  const getDokumenList = async () => {
    setDokumen([]);
    dokumenAPI.getDokumen().then((res) => {
      const dokumen = [
        ...res.data
      ];
      setDokumen(dokumen);
    });
  };

  const filterDokumen = (items) => {
    const filteredItems = items.filter(filterSearch(["judul"], filterText));
    return filteredItems;
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  return (
    <FeatureContainer
      title={"Dokumen"}
      createButton={checkPermission(PERMISSIONS.ADD_DOKUMEN) && <ModalUploadDokumen resetState={getDokumenList} />}
    >
      <DataTable
        columns={DaftarColumns(getDokumenList)}
        data={filterDokumen(dokumen)}
        highlightOnHover
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        theme={themeContext}
      />
    </FeatureContainer>
  );
};
export default DokumenContain;
